
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { addImageScaler } from "@/core";

@Component
export default class LazyImage extends Vue {
  private imageError='';
  private neighborhoodImageError = false;
  cssClassImageLoaded = false;
  private cssDefaultImage = false;
  private imgUrl = "";
  @Prop() private src!: string;
  @Prop() private alt!: string;
  @Prop() private isNeighborhoodImage!: boolean;
  @Prop() private showDefaultImage: boolean;

  @Watch('src') imageSrcUpdated(){
    this.imageError = '';
    this.neighborhoodImageError = false;
    this.cssClassImageLoaded = false;
    this.cssDefaultImage = this.showDefaultImage;
    this.imgUrl = this.src;
  }
  mounted(){
    this.imgUrl = this.src;
    this.cssDefaultImage = this.showDefaultImage
  }
  handleImageLoad(event:any) {
    this.cssClassImageLoaded = true;
  }
  onImageError(event: any) {
    if(!this.isNeighborhoodImage && !this.cssDefaultImage){      
      this.cssDefaultImage = true;
      this.imgUrl = addImageScaler(`${this.src.split("scale")[0]}`);
    } else if(this.cssDefaultImage){
      this.imgUrl = require("@/assets/images/home-not-available.png");      
    } else{
      this.neighborhoodImageError = true;
      this.imageError=this.alt.charAt(0);
    }
  }
}
